import { render, staticRenderFns } from "./TerminKalender.vue?vue&type=template&id=6d920ef9&"
import script from "./TerminKalender.vue?vue&type=script&lang=js&"
export * from "./TerminKalender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports